export const toRelativeUrl = (url) => {
  const value = String(url ?? "").trim();
  if (!value) return "";

  if (/^https?:\/\//i.test(value)) {
    try {
      const { pathname, search, hash } = new URL(value);
      return pathname + search + hash;
    } catch {
      return value;
    }
  }

  return value.startsWith("/") ? value : `/${value}`;
};
